<template>
  <div class="base-modal" v-if="modal" style="top:40px;">
    <div class="dialog">
      <header class="header">
        <span>{{title}}</span>
        <button @click="handleWrapperClick">Close</button>
      </header>
      <div class="body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "base-modal",
  props: {
    modal: {
      type: Boolean,
      require: true,
      default: false
    },
    title: {
      type: String,
      require: false
    }
  },
  watch: {
    modal: function(newVal, oldVal) {
      if (!newVal && oldVal) {
        console.log("BaseModal.vue <watch.modal.close>", "newVal", newVal);
        this.closeModal();
      }
      if (newVal && !oldVal) {
        console.log("BaseModal.vue <watch.modal.open>", "newVal", newVal);
        this.openModal();
      }
    }
  },
  methods: {
    hideScroll() {
      let elHtml = document.getElementsByTagName('html')[0];
      elHtml.style.overflowY = 'hidden';
    },
    showScroll() {
      let elHtml = document.getElementsByTagName('html')[0];
      elHtml.style.overflowY = 'auto';
    },
    handleWrapperClick() {
      this.$emit("update:modal", false);
    },
    openModal() {
      this.hideScroll();
      window.history.pushState({ name: "modal" }, "", "#modal");

      console.log("BaseModal.vue <openModal.state>", history.state);
      window.addEventListener("hashchange", this.handleWrapperClick);
    },
    closeModal() {
      var state = history.state;
      console.log("BaseModal.vue <closeModal.state>", state);
      if (state != null && state.name == 'modal') {
        window.history.back();
      }
      window.removeEventListener("hashchange", this.handleWrapperClick);
      this.showScroll();
    }
  }
};
</script>

<style>
.base-modal {
  background-color: rgba(256, 256, 256);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow: auto;
  margin: 0;
}

.base-modal .dialog {
  left: 0%;
  top: 15px;
  width: 100%;
  position: absolute;
  background: #fff;
}

.base-modal .dialog .header {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.29;
  padding: 16px 16px 0 25px;
  position: relative;
}
.base-modal .dialog .body {
  padding: 25px;
}
</style>